async function getData() {
  const RBTracking = (window as any).RBTracking;

  if (RBTracking) {
    return new Promise(function (resolve, reject) {
      RBTracking.getData(resolve, reject);
    });
  }

  return {
    success: false,
    data: null
  }
}

export const Tracking = {
  getData
}
